module.exports = __webpack_public_path__ + "img/syfol-spin.20589bde.gif";